import { Component, Input } from '@angular/core';
import { CustomValidatorsEnum, CustomValidatorsType, CUSTOM_VALIDATORS_STRING } from '@global-components/classes/custom-validators';

@Component({ standalone: false, selector: 'app-form-item-error',
  templateUrl: './item-error.component.html',
  styleUrls: ['./item-error.component.scss']
})
export class FormItemErrorComponent<T> {
  readonly customValidatorsString = CUSTOM_VALIDATORS_STRING;
  listaErrores: string[] = [];
  @Input() touched = false;
  @Input() set errors(errors: CustomValidatorsType) {
    if (!errors) {
      this.listaErrores = [];
      return;
    }
    this.listaErrores = Object.keys(errors).map((key) => {
      const validatorKey = key as CustomValidatorsEnum;
      return CUSTOM_VALIDATORS_STRING[validatorKey](errors[validatorKey]);
    });
  }
}
